import React from "react";
import { FieldError, type FieldErrorProps } from "react-aria-components";

export function FieldError2(props: FieldErrorProps) {
  return <FieldError className="tw:text-xs tw:text-text-error-primary" {...props} />;
}
